import { shareResource } from 'legacy/packages/unit-outline/src/queries';

/**
 * Saves resource sharing selected classes
 * @param {array} selectedItems The selected classes
 * @param {object} item Saved item
 * */
const shareResourceToClass = async (selectedItems, item, subject, client) => {
  const response = await client.mutate({
    mutation: shareResource,
    variables: {
      subject,
      resourceId: Number(item.resourceId),
      classIds: selectedItems.map(Number),
      resourceType: item.__typename,
    },
  });

  return response.data.shareResourceWithClass;
};

export default shareResourceToClass;
